import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import Ripples from "react-ripples";
import { useAxiosConfigGlobal } from "../../Config/axios";
import { distributionUrl } from "../../Config/url";
import { IconController, ImgController } from "../../Scripts/ImgController";
import CreationCard from "../../UI/Creation/CreationCard";
import assets from "../../../assets/assets";
import Pagination from "../../UI/pagination";
const Wrapper = styled.div`
  .table-border {
    border: 1px solid #e5e7eb;
  }
  .color-CK {
    color: #333843;
  }
  table {
    width: 100%;
  }
  .table-header {
    background: #f3f4f6;
  }
  .list td {
    width: 21.6%;
    padding: 24px;
  }
  .list td:first-child {
    width: 35.2%;
  }
  .skeleton td {
    width: 21.6%;
    padding: 12px 24px;
  }
  .skeleton td:first-child {
    width: 35.2%;
  }
  .text-color-grey {
    color: #6b7280;
  }
  tr {
    border-bottom: 1px solid #e5e7eb;
  }
  tr:last-child {
    border-bottom: none;
  }
  .table-footer {
    border-top: 1px solid #d1d5db;
    width: 100%;
    padding: 16px 24px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 6px;
  }
  .active {
    color: #ffffff;
    background-color: #0061ff;
  }
  @media (max-width: 767px) {
    .list td {
      padding: 12px;
    }
    .skeleton td {
      padding: 12px;
    }
    th .px-6 {
      padding: 12px;
    }
    .table-footer {
      flex-direction: column;
      gap: 12px;
      padding: 12px;
    }
  }
`;

const Creation = ({ oneRingRulesAll }) => {
  const [generalData, setGeneralData] = useState([]);
  const [likesCount, setLikesCount] = useState(Number);
  const [listensCount, setListensCount] = useState(Number);
  const [downloadsCount, setDownloadsCount] = useState(Number);
  const [songsList, setSongsList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [listMeta, setListMeta] = useState(Object);
  const [listSort, setListSort] = useState("");
  const [paginationLinks, setPaginationLinks] = useState([]);
  const [requestParams, setRequestParams] = useState(
    `panel-api/oauth/songs?sort=${listSort}&page[number]=${pageNumber}&page[size]=10`
  );
  const axiosConfig = useAxiosConfigGlobal();

  const [generalCardLoaded, setGeneralCardLoaded] = useState(false);
  const [card1Loaded, setCard1Loaded] = useState(false);
  const [card2Loaded, setCard2Loaded] = useState(false);
  const [card3Loaded, setCard3Loaded] = useState(false);
  const [listLoaded, setListLoaded] = useState(false);

  const [titleTime, setTitleTime] = useState(false);

  useEffect(() => {
    document.title = "MMusic - Уран бүтээл";
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("creation-generalData")) {
      const res = JSON.parse(sessionStorage.getItem("creation-generalData"));
      setGeneralData(res.data.data);
      setGeneralCardLoaded(true);
    } else {
      axios
        .get(distributionUrl + "panel-api/oauth/content:count", axiosConfig)
        .then((res) => {
          setGeneralData(res.data.data);
          setGeneralCardLoaded(true);
          sessionStorage.setItem("creation-generalData", JSON.stringify(res));
        })
        .catch((err) => {
          if (err.response.status === 401) {
            oneRingRulesAll("logout");
          }
        });
    }
    if (sessionStorage.getItem("creation-likesCount")) {
      const res = JSON.parse(sessionStorage.getItem("creation-likesCount"));
      setLikesCount(res.data.data);
      setCard1Loaded(true);
    } else {
      axios
        .get(distributionUrl + "panel-api/oauth/like:count", axiosConfig)
        .then((res) => {
          setLikesCount(res.data.data);
          setCard1Loaded(true);
          sessionStorage.setItem("creation-likesCount", JSON.stringify(res));
        })
        .catch((err) => {
          if (err.response.status === 401) {
            oneRingRulesAll("logout");
          }
        });
    }
    if (sessionStorage.getItem("creation-downloadCount")) {
      const res = JSON.parse(sessionStorage.getItem("creation-downloadCount"));
      setDownloadsCount(res.data.data);
      setCard2Loaded(true);
    } else {
      axios
        .get(distributionUrl + "panel-api/oauth/download:count", axiosConfig)
        .then((res) => {
          setDownloadsCount(res.data.data);
          setCard2Loaded(true);
          sessionStorage.setItem("creation-downloadCount", JSON.stringify(res));
        })
        .catch((err) => {
          if (err.response.status === 401) {
            oneRingRulesAll("logout");
          }
        });
    }
    if (sessionStorage.getItem("creation-listenCount")) {
      const res = JSON.parse(sessionStorage.getItem("creation-listenCount"));
      setListensCount(res.data.data);
      setCard3Loaded(true);
    } else {
      axios
        .get(distributionUrl + "panel-api/oauth/listen:count", axiosConfig)
        .then((res) => {
          setListensCount(res.data.data);
          setCard3Loaded(true);
          sessionStorage.setItem("creation-listenCount", JSON.stringify(res));
        })
        .catch((err) => {
          if (err.response.status === 401) {
            oneRingRulesAll("logout");
          }
        });
    }
  }, []);

  useEffect(() => {
    axios
      .get(distributionUrl + requestParams, axiosConfig)
      .then((res) => {
        setSongsList(res.data.data);
        setListMeta(res.data.meta);
        setPageNumber(res.data.meta.current_page);
        setListLoaded(true);
        setPaginationLinks(res.data.meta.links);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          oneRingRulesAll("logout");
        }
      });
  }, [requestParams]);

  const mappedList = songsList.map((song) => {
    return (
      <tr key={song.id} className="list">
        <td>
          <div className="flex flex-row items-center gap-2">
            <ImgController
              src={song.cover}
              className="w-12 h-12 object-cover"
              imgClassName="rounded-lg"
            />
            <div className="flex flex-col text-start ">
              <h5 className="text-xs font-medium text-color-grey">
                {song.artist.name}
              </h5>
              <h5 className="text-sm font-medium">{song.title}</h5>
              <h5 className="text-xs font-medium text-color-grey">
                {song.album.release_type === "standard" ? "Album" : "Single"}
              </h5>
            </div>
          </div>
        </td>
        <td>
          <span className="text-sm text-color-grey">{song.likes_count}</span>
        </td>
        <td>
          <span className="text-sm text-color-grey">
            {song.downloads_count}
          </span>
        </td>
        <td>
          <span className="text-sm text-color-grey">{song.listens_count}</span>
        </td>
      </tr>
    );
  });

  const ListSkeleton = () => {
    const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    return arr.map((a) => {
      return (
        <tr key={a} className="skeleton">
          <td>
            <div className="flex flex-row items-center gap-3">
              <Skeleton height="44px" width="44px" />
              <div className="flex flex-col w-full" height="32px">
                <Skeleton height="8px" width="50%" />
                <Skeleton height="8px" width="75%" />
                <Skeleton height="8px" width="25%" />
              </div>
            </div>
          </td>
          <td>
            <Skeleton width="50%" />
          </td>
          <td>
            <Skeleton width="50%" />
          </td>
          <td>
            <Skeleton width="50% " />
          </td>
        </tr>
      );
    });
  };

  const sortHandler = (value) => {
    setTitleTime(!titleTime);
    setListSort((titleTime ? "" : "-") + value);
    setRequestParams(
      `panel-api/oauth/songs?sort=${
        (titleTime ? "" : "-") + value
      }&page[number]=${pageNumber}&page[size]=10`
    );
  };

  return (
    <Wrapper className="py-4 px-1 md:py-8 md:px-5">
      <h5 className="text-mmusic text-xl font-semibold pb-3 pl-3">
        Уран бүтээлүүд
      </h5>
      <div className="flex flex-row flex-wrap">
        <CreationCard
          gradientColor="0061FF"
          number={generalData?.songs?.count}
          numberColor="1E3A8A"
          desc="Нийт уран бүтээл"
          descColor="3B82F6"
          icon={assets.svg.CardIcon1}
          loaded={generalCardLoaded}
        />

        <CreationCard
          gradientColor="F59E0B"
          number={generalData?.albums?.count}
          numberColor="92400E"
          desc="Нийт цомог"
          descColor="F59E0B"
          icon={assets.svg.CardIcon2}
          loaded={generalCardLoaded}
        />

        <CreationCard
          gradientColor="EC4899"
          number={generalData?.singles?.count}
          numberColor="9D174D"
          desc="Нийт сингл"
          descColor="EC4899"
          icon={assets.svg.CardIcon3}
          loaded={generalCardLoaded}
        />
        <CreationCard
          gradientColor="EF4444"
          number={likesCount}
          numberColor="991B1B"
          desc="Нийт таалагдсан"
          descColor="EF4444"
          icon={assets.svg.CardIcon4}
          loaded={card1Loaded}
        />
        <CreationCard
          gradientColor="8B5CF6"
          number={listensCount}
          numberColor="5B21B6"
          desc="Нийт татсан"
          descColor="8B5CF6"
          icon={assets.svg.CardIcon5}
          loaded={card2Loaded}
        />
        <CreationCard
          gradientColor="06B6D4"
          number={downloadsCount}
          numberColor="155E75"
          desc="Нийт сонсолтын тоо"
          descColor="06B6D4"
          icon={assets.svg.CardIcon6}
          loaded={card3Loaded}
        />
      </div>
      <div className="px-3 pt-2">
        <div className="table-border rounded-lg">
          <div className="px-4 md:px-6 py-4 md:py-5 flex flex-row justify-between items-center">
            <h4 className="font-medium text-base md:text-lg">Нийт уран бүтээлийн хүснэгт</h4>
          </div>
          <div className="overflow-x-auto">
          <table className="min-w-[640px]">
            <thead>
              <tr className="table-header">
                <th>
                  <Ripples color="#0061FF40" during={600} className="w-full">
                    <div
                      className="px-6 py-4 w-full flex flex-row justify-between cursor-pointer"
                      onClick={() => {
                        sortHandler("title");
                      }}
                    >
                      <h5 className="text-sm font-medium">Уран бүтээл</h5>
                      <IconController
                        src={assets.svg.ChevronDown}
                        className={`w-5 h-5 ${
                          listSort === "-title" ? "rotate-180" : ""
                        } `}
                      />
                    </div>
                  </Ripples>
                </th>
                <th>
                  <Ripples color="#0061FF40" during={600} className="w-full">
                    <div
                      className="px-6 py-4 w-full flex flex-row justify-between cursor-pointer"
                      onClick={() => {
                        sortHandler("likes_count");
                      }}
                    >
                      <h5 className="text-sm font-medium">Таалагдсан</h5>

                      <IconController
                        src={assets.svg.ChevronDown}
                        className={`w-5 h-5 ${
                          listSort === "-likes_count" ? "rotate-180" : ""
                        } `}
                      />
                    </div>
                  </Ripples>
                </th>
                <th>
                  <Ripples color="#0061FF40" during={600} className="w-full">
                    <div
                      className="px-6 py-4 w-full flex flex-row justify-between cursor-pointer"
                      onClick={() => {
                        sortHandler("downloads_count");
                      }}
                    >
                      <h5 className="text-sm font-medium">Таталт</h5>

                      <IconController
                        src={assets.svg.ChevronDown}
                        className={`w-5 h-5 ${
                          listSort === "-downloads_count" ? "rotate-180" : ""
                        } `}
                      />
                    </div>
                  </Ripples>
                </th>
                <th>
                  <Ripples color="#0061FF40" during={600} className="w-full">
                    <div
                      className="px-6 py-4 w-full flex flex-row justify-between cursor-pointer"
                      onClick={() => {
                        sortHandler("listens_count");
                      }}
                    >
                      <h5 className="text-sm font-medium">Сонсолт</h5>
                      {/* {listSort === "listens_count" ||
                      listSort === "-listens_count" ? ( */}
                      <IconController
                        src={assets.svg.ChevronDown}
                        className={`w-5 h-5 ${
                          listSort === "-listens_count" ? "rotate-180" : ""
                        } `}
                      />
                      {/* ) : (
                        ""
                      )} */}
                    </div>
                  </Ripples>
                </th>
              </tr>
            </thead>
            <tbody>{listLoaded ? mappedList : ListSkeleton()}</tbody>
          </table>
          </div>
          <div className="table-footer">
            <h5 className="text-sm font-medium text-center md:text-left">
              нийт {listMeta?.total} дуунаас {listMeta?.from}-{listMeta?.to}{" "}
              харуулж байна
            </h5>
            <div className="flex flex-wrap justify-center gap-1 md:gap-2 px-2 overflow-x-auto">
              <Pagination
                paginationLinks={paginationLinks}
                listMeta={listMeta}
                hostUrl={distributionUrl}
                setRequestParams={setRequestParams}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Creation;
